/* jshint node:true */
'use strict';

var React = require('react');
var jQuery = require('jquery');

var TabLinks = React.createClass({

    displayName: 'TabLinks',

    tabSelect: function(sTab,oEvent){
        if(this.props.changeView && sTab){
            if(sTab != 'table'){
                this.props.changeView(sTab);
                this.setState({
                    selected : sTab
                });
            }else{
                jQuery(".first-group a:contains('" + this.map[this.state.selected].label + "')").parent().addClass('active');
            }
            this.hideMoreLinks();
        }
    },

    getInitialState: function () {
        return {
            selected : (this.props.selected && this.props.selected !== 'match') ? this.props.selected : 'summary',
            availableTabCount : 0
        };
    },

    componentDidMount: function() {
        window.addEventListener('resize', this.throttle(this.handleResize, 150));
        window.addEventListener('orientationchange', this.throttle(this.handleResize, 150));
        this.handleResize();
    },

    componentWillUnmount: function() {
        window.removeEventListener('resize', this.handleResize);
        window.removeEventListener('orientationchange', this.handleResize);
    },

    handleResize: function(){
        this.hideMoreLinks();
        var count = this.calcLinks();
        this.setState({
            availableTabCount : count
        });
    },

    calcLinks: function(){
        var lis = jQuery('.first-group li');
        var totalWidth = 0;
        var windowWidth = jQuery(window).outerWidth();

        for(var i=0, len=lis.length; i < len; i++){
            var outerWidth = jQuery(lis[i]).outerWidth();
            if( totalWidth + outerWidth + 100 > windowWidth ){
                //return i;
                return 8;
            }else{
                totalWidth += outerWidth;
            }
        }
        return 8;
    },

    componentWillReceiveProps: function(nextProps) {
        if(nextProps.selected){
            this.setState({
                selected : (nextProps.selected !== 'match') ? nextProps.selected : 'summary'
            });
        }
    },

    componentDidUpdate: function(prevProps, prevState) {
        // If game status has changed, re-render tabs
        if(prevProps.matchState !== this.props.matchState){
            this.handleResize();
        }
    },

    getLiClassName: function(current) {
        var liClassName = "sub";
            if(this.state.selected === current){
                liClassName += " active";
            }
        return liClassName;
    },

    availableTabs: {
        pre : [ 'summary', 'preview', 'commentary', 'lineups', 'table', 'conversation'],
        live : [ 'summary', 'commentary', 'matchstats', 'playerstats', 'lineups', 'table', 'conversation'],
        post : [ 'summary', 'report', 'commentary', 'matchstats', 'playerstats', 'lineups', 'table', 'conversation'],
    },

    map: {
        summary : {
            label : 'Summary'
        },
        commentary : {
            label : 'Commentary'
        },
        matchstats : {
            label : 'Match Stats'
        },
        playerstats : {
            label : 'Player Stats'
        },
        lineups : {
            label : 'Line-ups'
        },
        table : {
            label : 'Table'
        },
        report : {
            label : 'Report'
        },
        preview : {
            label : 'Preview'
        },
        conversation : {
            label : 'Conversation'
        }
    },

    throttle : function(callback, limit) {
        var wait = false;
        return function () {
            if (!wait) {
                callback.call();
                wait = true;
                setTimeout(function () {
                    wait = false;
                }, limit);
            }
        };
    },

    toggleMoreLinks: function(e){
        try{
            if(jQuery('.has-sub .sub-content').is(':visible')){
                jQuery('.tertiary-nav-container').attr('style', '');
                jQuery('.has-sub .sub-content').hide();
            }else{
                jQuery('.tertiary-nav-container').attr('style', 'overflow:visible');
                jQuery('.has-sub .sub-content').attr('style', 'display: block; height: 210px; width: 195px; left: -80px!important');
            }
        }catch(ex){}
    },

    hideMoreLinks: function(){
        jQuery('.has-sub .sub-content').hide();
    },

    buildLinks: function(links){

        var sState          = this.props.matchState || 'pre'; //pre,post,live
        var bCommentaryLink = this.props.commentaryLink || false;
        var bStandingsLink  = this.props.standingsLink || false;
        var bStatsLink      = this.props.statsLink || false;
        var bReportLink     = this.props.reportLink || false;
        var bPreviewLink    = this.props.previewLink || false;
        var tabs            = [];

        for (var i = 0, len = links.length; i < len; i++) {
            var link = links[i];
            var extLink = this.map[link].href || this.props.tableHref;
            var anchorProps = {};

            if(link === 'report' && bReportLink === false){
                continue;
            }else if(link === 'preview' && bPreviewLink === false){
                continue;
            }

            if(((link === 'matchstats' || link === 'playerstats' ) && bStatsLink === false) || (link === 'commentary' && bCommentaryLink === false) || (link === 'table' && bStandingsLink === false)){
                continue;
            }

            if(link === 'table' && extLink){
                anchorProps.href = extLink;
                anchorProps.style = {color:'#000'};
                //anchorProps.target = "_blank";
                anchorProps['data-route'] = 'false';
            }

            anchorProps.onClick = this.tabSelect.bind(this, link);

            var sLabel = this.map[link].label || '';
            if(link === 'summary' && sState == 'live'){
                sLabel = 'Live';
            }
            tabs.push(
                <li key={link} className={"sub" + (this.state.selected == link ? ' active' : '') }><a {...anchorProps}><span className="link-text">{sLabel}</span><span className="link-text-short">{sLabel}</span></a></li>
            );
        }
        return tabs;
    },

    render: function () {

        var sState          = this.props.matchState || 'pre'; //pre,post,live
        var links           = this.availableTabs[sState] || [];
        var availableTabCount = this.state.availableTabCount || links.length;
        var tabs            = [];
        var visibleLinks    = links.slice(0, availableTabCount);
        var moreLinks       = (visibleLinks === availableTabCount) ? [] : links.slice(availableTabCount);

        tabs = this.buildLinks(visibleLinks);

        if(moreLinks.length){
            tabs.push(
                <li key="more.links" className="has-sub" itemProp="name" style={{display: "inline-block"}}>
                    <a itemProp="url" onClick={this.toggleMoreLinks} ><span className="link-text">More</span><span className="link-text-short">More</span></a>
                    <div className="sub-content">
                        <ul>
                            {this.buildLinks(moreLinks)}
                        </ul>
                    </div>
                </li>
            );
        }

        return (
            <nav id="global-nav-tertiary" className="game-package-nav" style={{display:'block'}}>
                <div className="tertiary-nav-container">
                    <ul className="first-group focused">
                        {tabs}
                    </ul>
                </div>
            </nav>
        );
    }
});

module.exports = TabLinks;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/TabLinks.jsx
 **/